import React from 'react';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import Typography, { TypographyProps } from '@material-ui/core/Typography';

const useStyles = makeStyles(() =>
  createStyles({
    sectionTitle: {
      fontSize: 20,
      lineHeight: '25px',
      fontWeight: 600,
    },
    sectionTitleLarge: {
      fontSize: 24,
      lineHeight: '30px',
      fontWeight: 600,
      marginBottom: 24,
    },
  }),
);

export interface FormSectionTitleProps extends TypographyProps {
  large?: boolean;
}

export default function FormSectionTitle(props: FormSectionTitleProps) {
  const { large, ...rest } = props;
  const classes = useStyles();

  return (
    <Typography className={large ? classes.sectionTitleLarge : classes.sectionTitle} {...rest} />
  );
}
